export default "__VITE_ASSET__CO0sJI3E__"